import { mapMutations } from 'vuex'
import triplaLocalStorage from 'utilities/triplaLocalStorage'

export default {
  data() {
    return {
      reloadKey: 0
    }
  },

  methods: {
    ...mapMutations('search', ['setRooms', 'setPlans']),
    changeLocale(value) {
      this.$i18n.locale = value
      triplaLocalStorage.setItem('triplabot_locale', value)
      this.reloadKey++
      this.setRooms(null)
      this.setPlans(null)
      if (this.$route.query.locale) {
        this.$router.replace({
          ...this.$router.currentRoute,
          query: {
            ...this.$route.query,
            locale: undefined
          }
        })
      }
    }
  }
}
